<ng-container >
  <h1 class="form-title mt-4" translate>finance-data.bank</h1>
  <form class="bankdata-form" [formGroup]="bankDataForm">
    <div>
      <kendo-formfield class="text-field">
        <kendo-label [for]="nameDesKreditInstituts" class="form-label" [text]="appendAsteriskIfRequired('finance-data.bank.name' | translate)" [infotooltip]="'finanzdaten.namedeskreditinstituts'"></kendo-label>
        <kendo-textbox #nameDesKreditInstituts formControlName="nameDesKreditInstituts" [appinfotext]="'finanzdaten.namedeskreditinstituts'"
          preventEmptyFormatter [maxlength]=100
        (paste)="this.textBoxService.onPaste($event, this.bankDataForm.NameDesKreditInstituts, 100)"
        >
        </kendo-textbox>
      </kendo-formfield>

      <kendo-formfield class="text-field">
        <kendo-label [for]="kontoinhaber" class="form-label" [text]="appendAsteriskIfRequired('finance-data.bank.accountHolder' | translate)" [infotooltip]="'finanzdaten.kontoinhaber'"></kendo-label>
        <kendo-textbox #kontoinhaber formControlName="kontoinhaber" [appinfotext]="'finanzdaten.kontoinhaber'"
          preventEmptyFormatter [maxlength]=100
        (paste)="this.textBoxService.onPaste($event, this.bankDataForm.Kontoinhaber, 100)"
        >
        </kendo-textbox>
      </kendo-formfield>
    </div>
    <div>
      <kendo-formfield class="text-field">
        <kendo-label [for]="iban" class="form-label" [text]="appendAsteriskIfRequired('finance-data.bank.accountNumber' | translate)" [infotooltip]="'finanzdaten.iban'"></kendo-label>
        <kendo-textbox
          #iban
          formControlName="iban"
          [appinfotext]="'finanzdaten.iban'"
          preventEmptyFormatter
          [maxlength]=100
          (paste)="this.textBoxService.onPaste($event, this.bankDataForm.Iban, 100)"
          (input)="onIbanInput($event)"
        >
        </kendo-textbox>
        <kendo-formerror *ngIf="ibanErrorMessage">{{ibanErrorMessage}}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield class="text-field">
        <kendo-label [for]="bic" class="form-label" [text]="appendAsteriskIfRequired('finance-data.bank.bic' | translate)" [infotooltip]="'finanzdaten.bic'"></kendo-label>
        <kendo-textbox #bic formControlName="bic" [appinfotext]="'finanzdaten.bic'" preventEmptyFormatter [maxlength]=100
        (paste)="this.textBoxService.onPaste($event, this.bankDataForm.Bic, 100)" (input)="onBicInput($event)"
        ></kendo-textbox>
        <kendo-formerror *ngIf="bicErrorMessage">{{bicErrorMessage}}</kendo-formerror>
      </kendo-formfield>
    </div>
  </form>
</ng-container>